(() => {
  'use strict';
  if (customElements.get('mvp-kit-system')) return;
  class MvpKitSystem extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.mount = document.querySelector('[data-custom-kit-mount], [data-usa-kit-order] [data-kit-mount], gameday-authentic-kit-configurator [data-kit-mount]');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-include-kit-mount]');
        if (!button || !this.mount || this.mount.disabled) return;
        this.mount.click(); // Use the kit's existing price, quantity and cart logic.
        this.syncMount();
      }, { signal });
      this.mount?.addEventListener('change', () => this.syncMount(), { signal });
      this.observer = new MutationObserver(() => this.syncMount());
      if (this.mount) this.observer.observe(this.mount, { attributes: true, attributeFilter: ['disabled'] });
      const kitPrice = this.kitPrice = document.querySelector('[data-custom-order-price], [data-usa-kit-order] [data-kit-total], gameday-authentic-kit-configurator [data-kit-total]');
      if (kitPrice) this.observer.observe(kitPrice, { childList: true, characterData: true, subtree: true });
      document.addEventListener('click', event => {
        const anchor = event.target.closest('a[href="#mvp-kit-extra-flags"]');
        if (anchor) { const extras = this.querySelector('#mvp-kit-extra-flags'); if (extras) extras.open = true; }
      }, { signal });
      this.syncMount();
      this.form = this.querySelector('[data-extra-flag-form]');
      if (!this.form) return;
      this.size = this.form.querySelector('[data-extra-flag-size]');
      this.addButton = this.form.querySelector('[data-extra-flag-add]');
      this.size.addEventListener('change', () => this.syncFlag(), { signal });
      this.form.addEventListener('submit', event => this.addFlag(event), { signal, capture: true });
      this.syncFlag();
    }
    syncMount() {
      const active = !!this.mount?.checked;
      const available = !!this.mount && !this.mount.disabled;
      this.querySelectorAll('[data-include-kit-mount]').forEach(button => {
        button.disabled = !available;
        button.setAttribute('aria-pressed', String(active));
        const price = document.createElement('strong');
        price.className = 'mvp-kit-mount-price';
        price.textContent = `${this.dataset.mountPrice} / kit`;
        button.replaceChildren(document.createTextNode(active ? 'Mount added ✓' : available ? 'Add mount +' : 'Unavailable'), price);
        button.setAttribute('aria-label', active ? 'Remove Surface Mount from this kit' : available ? `Add Surface Mount to this kit for ${this.dataset.mountPrice}` : 'Surface Mount unavailable');
      });
      const total = this.querySelector('[data-assembly-kit-total]');
      if (total) total.textContent = this.dataset.proKitBasePrice ? (active ? this.dataset.proKitMountedPrice : this.dataset.proKitBasePrice) : this.kitPrice?.textContent.trim() || ''; 
      const status = this.querySelector('[data-kit-mount-status]');
      if (status) status.textContent = active ? `Surface Mount selected · ${this.dataset.mountPrice} per kit. MM screws included.` : available ? `Optional · ${this.dataset.mountPrice} per kit. MM screws included with the mount.` : 'The Surface Mount cannot be added to this kit right now.';
    }
    syncFlag() {
      const available = this.size.selectedOptions[0]?.dataset.available === 'true';
      this.addButton.disabled = this.busy || !available;
      this.addButton.textContent = this.busy ? 'Adding…' : available ? `Add flag · ${this.size.selectedOptions[0].dataset.price}` : 'Flag unavailable';
    }
    async addFlag(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.addButton.disabled || !this.form.reportValidity()) return;
      const quantity = Number(this.form.elements.quantity.value);
      const id = Number(this.size.value);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity < 1 || quantity > 20) return;
      const status = this.form.querySelector('[data-extra-flag-status]');
      const cartLink = this.form.querySelector('[data-extra-flag-cart]');
      this.busy = true;
      status.textContent = '';
      cartLink.hidden = true;
      this.size.disabled = true;
      this.form.elements.quantity.disabled = true;
      this.syncFlag();
      try {
        const response = await fetch(`${this.dataset.shopRoot || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Unable to add this flag.');
        status.textContent = `${quantity} extra USA ${quantity === 1 ? 'flag' : 'flags'} added to your cart.`;
        cartLink.hidden = false;
        try {
          const countResponse = await fetch(`${this.dataset.shopRoot || '/'}cart.js`, { headers: { Accept: 'application/json' } });
          if (countResponse.ok) {
            const cart = await countResponse.json();
            if (Number.isInteger(cart.item_count)) document.querySelectorAll('[data-header-cart-count]').forEach(el => { el.textContent = cart.item_count; });
          }
        } catch (_) { /* The add succeeded; a count refresh is optional. */ }
      } catch (error) {
        status.textContent = `${error.message || 'Unable to confirm the add.'} Check your cart before trying again.`;
        cartLink.hidden = false;
      } finally {
        this.busy = false;
        this.size.disabled = false;
        this.form.elements.quantity.disabled = false;
        this.syncFlag();
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
  }
  customElements.define('mvp-kit-system', MvpKitSystem);
})();
